import { send_request_optional_auth } from '../../../../utils/Request';

function idempotencyKey() {
  return crypto.randomUUID();
}

function buildHeaders(grantToken) {
  const headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
  if (grantToken) headers['x-verification-grant-token'] = grantToken;
  return headers;
}

export function createAgentAdapter(token) {
  return {
    storagePrefix: 'w86_ml_grant_',

    capabilities: {
      canSaveDraft: true,
      canUpload: true,
      hasServerValidation: true,
      hasProgressStatus: true,
      canRefresh: true,
      showConfirmationOnSubmit: false,
    },

    async bootstrap() {
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}/bootstrap`, '', {}, 'GET'
      );
      const data = response?.data || {};
      return {
        requiresAuth: false,
        requiresEmailVerification: Boolean(data.requiresEmailVerification),
        disabled: false,
      };
    },

    async loadForm(grantToken) {
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}`, '', {}, 'GET', buildHeaders(grantToken)
      );
      return response?.data || null;
    },

    async saveDraft(answers, grantToken) {
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}/draft`,
        { answers, idempotencyKey: idempotencyKey() },
        {},
        'POST',
        buildHeaders(grantToken)
      );
      return response?.data || {};
    },

    async validate(answers, grantToken) {
      // Agent forms validate on draft save
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}/draft`,
        { answers, idempotencyKey: idempotencyKey() },
        {},
        'POST',
        buildHeaders(grantToken)
      );
      return response?.data || {};
    },

    async submit(answers, grantToken) {
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}/submit`,
        { answers, idempotencyKey: idempotencyKey() },
        {},
        'POST',
        buildHeaders(grantToken)
      );
      return response?.data || {};
    },

    async upload(fieldKey, file, grantToken) {
      const formData = new FormData();
      formData.append('file', file);
      if (fieldKey) formData.append('fieldKey', fieldKey);
      const response = await send_request_optional_auth(
        `project-service/agent-form/${token}/upload`,
        formData,
        '',
        'POST',
        {
          'content-type': 'multipart/form-data',
          ...(grantToken ? { 'x-verification-grant-token': grantToken } : {}),
        }
      );
      return response?.data || null;
    },

    async requestMagicLink(email) {
      await send_request_optional_auth(
        `project-service/agent-form/${token}/magic-link/request`, '', { email }, 'POST'
      );
    },

    async verifyMagicLink(verificationToken) {
      const response = await send_request_optional_auth(
        `project-service/agent-form/magic-link/verify`, '', { verificationToken }, 'POST'
      );
      return response?.data;
    },

    deriveReadOnly(form) {
      if (!form) return false;
      const canEdit = Boolean(form.resolvedPermissions?.canEdit);
      const canSubmit = Boolean(form.resolvedPermissions?.canSubmit);
      return (
        form.responseMode === 'VIEW_ONLY' ||
        form.locked ||
        form.progressStatus === 'CANCELLED' ||
        (!canEdit && !canSubmit)
      );
    },

    deriveCanSubmit(form) {
      return Boolean(form?.resolvedPermissions?.canSubmit);
    },

    deriveCanEdit(form) {
      return Boolean(form?.resolvedPermissions?.canEdit);
    },
  };
}
